import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiAccessoriL1SectionWrapper,
  InspectionInfoScheda20Form,
} from 'components';
import {
  marciapiedePresenteOptions,
  schemaPonteCommonOptions,
  tipologiaMarciapiedeOptions,
} from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import MarciapiediForm from './MarciapiediForm';
const MarciapiediSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();

  const sovrastrutturaImpalcatoTableMarciapiediTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`
  );

  const sovrastrutturaImpalcatoTable = watch(`sovrastrutturaImpalcatoTable`);
  //console.log(sovrastrutturaImpalcatoTable, 'sovrastrutturaImpalcatoTable');

  const mensoleTamponiCampateToCopy = sovrastrutturaImpalcatoTable?.map(
    el => el.marciapiediTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsMarciapiedi = item => {
    setValue('marciapiediTableValue', [item]);
    setValue('tipologiaMarciapiedeTableValue', item.tipologiaMarciapiede);
    setValue('marciapiedePresenteTableValue', item.marciapiedePresente);
  };

  const handleSelectAllClickMarciapiedi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`
      );
      setSelected(selectedValue);
      setValue('marciapiediTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('marciapiediTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t3a2_tecnicoRilevatoreMarciapiedi',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t3a2_dataIspezioneMarciapiedi',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t3a2_noteGeneraliMarciapiedi',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues('l1t3a2_tecnicoRilevatoreMarciapiedi');
    const dataIspezione = getValues('l1t3a2_dataIspezioneMarciapiedi');

    const noteGenerali = getValues('l1t3a2_noteGeneraliMarciapiedi');
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
  };

  const handleResetInspection = () => {
    setValue(`l1t3a2_tecnicoRilevatoreMarciapiedi`, '');
    setValue(`l1t3a2_dataIspezioneMarciapiedi`, null);
    setValue(`l1t3a2_noteGeneraliMarciapiedi`, '');
  };

  const dataMarciapiediConfig = {
    columns: {
      codice: { label: 'Cod.' },
      presenza: { label: 'Marciapiede', format: schemaPonteCommonOptions },
      tipologiaMarciapiede: {
        label: 'Tipologia',
        format: tipologiaMarciapiedeOptions,
      },
      marciapiedePresente: {
        label: 'Tipologia',
        format: marciapiedePresenteOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      nrtotali: { label: 'NR' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaMarciapiede: {
        label: 'Tipologia',
        format: tipologiaMarciapiedeOptions,
      },
    },
  };

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiAccessoriL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'marciapiedi'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoMarciapiede.drawerTitle}
        drawerText={INFO.impalcatoMarciapiede.drawerText}
        singleElementTitle={'marciapiede'}
        tableWatch={sovrastrutturaImpalcatoTableMarciapiediTableWatch}
        tableWatchName={`sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`}
        elementForm={
          <MarciapiediForm
            marciapiediFields={
              sovrastrutturaImpalcatoTableMarciapiediTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            marciapiediTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].marciapiediTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoScheda20Form
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t3a2_tecnicoRilevatoreMarciapiedi'}
            dateName={'l1t3a2_dataIspezioneMarciapiedi'}
            noteGeneraliName={'l1t3a2_noteGeneraliMarciapiedi'}
          />
        }
        tableConfig={dataMarciapiediConfig}
        editRows={editRowsMarciapiedi}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickMarciapiedi}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaMarciapiede'}
        tableForCopy={mensoleTamponiCampateToCopy}
      />
    </>
  );
};
MarciapiediSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default MarciapiediSection;
